import type { UseQueryResult } from '@tanstack/react-query';
import { isRegistered } from '../../contexts/utils/customer-utils';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useCustomerGet } from './useCustomerGet';
import type { CustomerProductList } from './model';

export const useGetCustomerWishLists = (): UseQueryResult<CustomerProductList[]> => {
    const { data } = useCustomerGet();

    return useBffGet(
        ({ customer_id }) => `/customers/${customer_id}/wish-lists`,
        [],
        [BffQueryKey.CUSTOMER_WISH_LISTS],
        { enabled: isRegistered(data) },
    );
};
